import React from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import { AgroOverviewLayersState } from 'types/Meteorology/Agro/Overview/Dashboard';
import {
  selectAgroOverviewLayers,
  toggleLayer,
} from 'redux/reducers/meteorologyAgroOverviewDashboardReducer';

import './index.scss';

const LAYER_ROWS: { key: keyof AgroOverviewLayersState; label: string }[] = [
  { key: 'localidades', label: 'Localidades' },
  { key: 'alertas', label: 'Alerta de Estresse' },
  { key: 'limitesEstaduais', label: 'Limites estaduais' },
];

export default function LayersSheet({
  open,
  dismiss,
}: {
  open: boolean;
  dismiss: () => void;
}) {
  const dispatch = useDispatch();
  const layers = useSelector(selectAgroOverviewLayers);

  return (
    <BottomSheet
      open={open}
      dismiss={dismiss}
      title="Camadas"
      className="agro-overview-mobile-layers-sheet"
    >
      <div className="agro-overview-mobile-layers-list">
        {LAYER_ROWS.map((row) => (
          <Form.Check
            key={row.key}
            type="switch"
            id={`mobile-layer-${row.key}`}
            label={row.label}
            checked={layers[row.key]}
            onChange={() => dispatch(toggleLayer(row.key))}
          />
        ))}
      </div>
    </BottomSheet>
  );
}
